import ComparingPrices from "../../components/ClassTwo/NumberMath/ComparingPrice";
import CountingMoney from "../../components/ClassTwo/NumberMath/CountingMoney";
import IdentifyingMoney from "../../components/ClassTwo/NumberMath/IdentifyingMoney";
import FindingCombinations from "../../components/ClassTwo/NumberMath/MoneyCombination";
import SortingGrouping from "../../components/ClassTwo/NumberMath/SortingGrouping";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/number-math/money-identifying", title: "Identifying", component: IdentifyingMoney },
    { url: "/class-two/number-math/money-calculate-money", title: "Counting Money", component: CountingMoney },
    { url: "/class-two/number-math/money-sorting-grouping", title: "Sorting & Grouping", component: SortingGrouping },
    { url: "/class-two/number-math/money-comparing-prices", title: "Comparing Prices", component: ComparingPrices }
    // { url: "/class-two/number-math/money-finding-combinations", title: "Combinations", component: FindingCombinations },
    // { url: "/class-two/number-math/money-making-change", title: "Making Change", component: FindingCombinations },
    // { url: "/class-two/number-math/money-buying-items", title: "Buying Items", component: FindingCombinations },
    // { url: "/class-two/number-math/money-saving-money", title: "Saving Money", component: FindingCombinations },
    // { url: "/class-two/number-math/money-spending-money", title: "Spending Money", component: FindingCombinations },
    // { url: "/class-two/number-math/money-word-problem", title: "Word Problem", component: FindingCombinations }
];

export default topics;